// Album access-code format. Pinned to common-contracts/album_access_code.json
// (see albumAccessCode.test.ts). UX/generation convention only — the server does
// not validate the charset.
export const ACCESS_CODE_CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZ123456789';
export const ACCESS_CODE_LENGTH = 10;

// Matches the charset above (no I, O, or 0). Used for admin input validation.
export const ACCESS_CODE_RE = /^[A-HJ-NP-Z1-9]+$/;

// Normalize user-entered codes: uppercase and strip spaces/dashes so grouped or
// lowercase entry still works.
export const normalizeAccessCode = (raw: string): string =>
  raw.replace(/[\s-]/g, '').toUpperCase();

// Generate a fresh random access code from the charset above, e.g. for admin
// "regenerate code" actions.
export const generateAccessCode = (): string => {
  const arr = new Uint32Array(ACCESS_CODE_LENGTH);
  crypto.getRandomValues(arr);
  return Array.from(arr, (n) => ACCESS_CODE_CHARSET[n % ACCESS_CODE_CHARSET.length]).join('');
};
